import React, { useState ,useEffect} from "react";
import SearchByProductsDropdown from "./SearchByProductsDropdown";
import { Container, Card, Row, Col, Alert, Button, Image } from 'react-bootstrap';
import ClarityLogo from "../assets/images/clarity-logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-svg-core";
import "@fortawesome/react-fontawesome";
import "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import DataTableCard from "./AdminDataPanel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import AdminDataPanel from "./AdminDataPanel";
import { Multiselect } from "multiselect-react-dropdown";
 import { OverlayTrigger, Tooltip, DropdownButton,  } from 'react-bootstrap';
import { MultiSelect } from "react-multi-select-component";
import config from "../config";

const AdminPanel = () => {


  useEffect(() => {
    console.log("Username from sessionStorage:", sessionStorage.getItem('username'));
  }, []);

  const [username, setUsername] = useState(sessionStorage.getItem('username'));
  const [userFirstname, setFirstName] = useState(sessionStorage.getItem('firstname'));
  const [decodedToken, setDecodedToken] = useState(sessionStorage.getItem('decodedToken'));
  const [bearerToken, setBearerToken] = useState(sessionStorage.getItem('bearerToken'));

  console.log("Username from sessionStorage:", username);
 

  

  // State to hold selected options
  const[optionsDate,setOptionsDate] =useState([]);
  const[optionsProducts,setOptionsProducts] =useState([]);
  const[optionsStatus,setOptionsStatus] =useState([]);
  const[optionsOwner,setOptionsOwner] =useState([]);
  const[salesRepOptions,setSalesRepOptions] =useState([]);
  const[sourceOptions,setuniqueSourceOptions] =useState([]);
  const [selectedOptionsDate, setSelectedOptionsDate] = useState([]);
  const [selectedOptionsProducts, setSelectedOptionsProducts] = useState([]);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [selectedOptions3, setSelectedOptions3] = useState([]);
  const [selectedOptionsOwner, setSelectedOptionsOwner] = useState([]);
  const [selectedOptionsCrmName, setSelectedOptionsCrmName] = useState([]);
  const [optionsCrmName, setOptionsCrmName] = useState([]);
  const [adminData, setAdminData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);

  // Handler for when the dropdown selection changes
  const handleSelectChange = (selected) => {
    setSelectedOptionsDate(selected);
  };
  const handleSelectChangeProducts = (selected) => {
    setSelectedOptionsProducts(selected || []);
};
  const handleSelectChangeStatus = (selected) => {
    setSelectedOptionsStatus(selected);
  };
  const handleSelectChange3 = (selected) => {
    setSelectedOptions3(selected);
  };
  const handleSelectChangeOwner = (selected) => {
    setSelectedOptionsOwner(selected);
  };
  const handleSelectChangeCrmName = (selected) => {
    setSelectedOptionsCrmName(selected);
  };

  // State to hold selected options

  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to toggle dropdown visibility

  
 
  

  

   
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${config.API_URL}/renewalcases`);
        const data = await response.json();
        
        // renewal Date
        const uniqueRenewalDate = new Set(data.map(item => item.renewalDate).filter(name => name));

        // Format the options for the select component
        const formattedOptions = Array.from(uniqueRenewalDate).map(name => ({
          value: name,
          label: name,
        }));
        setOptionsDate(formattedOptions);


        // Ensure unique CRM names
        const uniqueCrmNames = new Set(data.map(item => item.crmName).filter(name => name));

        // Format the options for the CRM select component
        const formattedCrmOptions = Array.from(uniqueCrmNames).map(name => ({
          value: name,
          label: name,
        }));

        setOptionsCrmName(formattedCrmOptions);

        // Ensure unique products
        const uniqueProducts = new Set(data.map(item => item.products).filter(name => name));

        // Format the options for the product select component
        const formattedProductOptions = Array.from(uniqueProducts).map(name => ({
          value: name,
          label: name,
        }));

        setOptionsProducts(formattedProductOptions);


        // Ensure unique CRM names
        const uniqueStatus = new Set(data.map(item => item.caseStatus).filter(name => name));

        // Format the options for the select component
        const formattedStatusOptions = Array.from(uniqueStatus).map(name => ({
          value: name,
          label: name,
        }));

        setOptionsStatus(formattedStatusOptions);


        // Ensure unique CRM names
        const uniqueSalesRepName = new Set(data.map(item => item.salesRepName).filter(name => name));

        // Format the options for the select component
        const formattedSalesRepOptions = Array.from(uniqueSalesRepName).map(name => ({
          value: name,
          label: name,
        }));

        setSalesRepOptions(formattedSalesRepOptions);

        const uniqueSource = new Set(data.map(item => item.qbnpmFileSource).filter(name => name));

        // Format the options for the select component
        const formatteduniqueSource = Array.from(uniqueSource).map(name => ({
          value: name,
          label: name,
        }));

        setuniqueSourceOptions(formatteduniqueSource);


          // Ensure unique CRM names
          const uniqueCaseOwner = new Set(data.map(item => item.caseOwnerName).filter(name => name));

          // Format the options for the select component
          const formattedCaseOwnerOptions = Array.from(uniqueCaseOwner).map(name => ({
            value: name,
            label: name,
          }));
  
          setOptionsOwner(formattedCaseOwnerOptions);
         

          setAdminData(data);
                setFilteredData(data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }finally {
        setLoading(false); 
      }
    };

    fetchData();
  }, []);


  

  // State for selected sales reps
  const [selectedSalesReps, setSelectedSalesReps] = useState([]);
  const [selectedSource, setSelectedSource] = useState([]);

  // Handle change when sales rep(s) are selected
  const handleSalesRepChange = (selectedOptions) => {
    setSelectedSalesReps(selectedOptions);
  };

  const handleSourceChange = (selectedOptions) => {
    setSelectedSource(selectedOptions);
  };

  // Toggle the dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const [isOpen, setIsOpen] = useState(false); // Step 1: State for toggle
  const [isOpen1, setIsOpen1] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen); // Step 2: Toggle state
  };

  const closeDropdown = () => {
    setIsOpen1(false);
  };

  // const handleOptionClick = (option) => {
  //   setSelectedOptions((prevSelected) =>
  //     prevSelected.includes(option)
  //       ? prevSelected.filter((o) => o !== option)
  //       : [...prevSelected, option]
  //   );
  // };

  const [filters, setFilters] = useState({
    clientName: "",
    implementationDate: [],
    sfCaseId: "",
    products: [],
    caseStatus: [],
    isReady: [],
    kickOffCall: [],
    caseOwners: [],
    crmName: [],
    salesRepName: [],
    impContactEmail: "",
  });

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setFilters({ ...filters, [id]: value });
  };

  const [clientName, setClientName] = useState("");
  const [salesforceCaseId, setSalesforceCaseId] = useState("");
  const [sfCaseId, setSfCaseId] = useState("");
  const [implementationDate, setImplementationDate] = useState([]);
  const [products, setProducts] = useState([]);
  const [caseStatus, setCaseStatus] = useState([]);
  const [isReady, setIsReady] = useState([]);
  const [kickOffCall, setKickOffCall] = useState([]);
  const [caseOwners, setCaseOwners] = useState([]);
  const [crmName, setCrmName] = useState([]);
  const [salesRepName, setSalesRepName] = useState([]);
  const [impContactEmail, setImpContactEmail] = useState("");

  const handleClientNameSearch = (event) => {
    setClientName(event.target.value);
  };

  const handleSalesforceCaseIdSearch = (event) => {
    setSalesforceCaseId(event.target.value);
  };

  const handleFilter = () => {
    // Handle filter logic here (API calls, filtering data, etc.)
    console.log({
      clientName,
      sfCaseId,
      implementationDate,
      products,
      
      caseStatus,
      kickOffCall,
      caseOwners,
      crmName,
      salesRepName,
      impContactEmail,
    });
  };

  const handleClear = () => {
    setClientName("");
    setSalesforceCaseId("");
    setSelectedOptionsDate([]);
    setProducts([]);
    setCaseStatus([]);
    setSelectedSalesReps([]);
    setSelectedSource([]);
    setCaseOwners([]);
    setSelectedOptionsCrmName([]);
    setSalesRepName([]);
    setImpContactEmail("");
    setSelectedOptionsOwner([]);
    setSelectedOptions3([]);
    setSelectedOptionsStatus([]);
    setSelectedOptionsProducts([]);
  };

//   useEffect(() => {
//     // Initialize Bootstrap tooltips
//     const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
//     tooltipTriggerList.map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));
// }, []);
const renderTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search by clientName.
  </Tooltip>
);
const renderTooltipRenewal = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Renewal Date
  </Tooltip>
);
const renderTooltipCaseId = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search By SF Case Id
  </Tooltip>
);

const renderTooltipProduct = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search By Products
  </Tooltip>
);
const renderTooltipCaseStatus = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search By Case status
  </Tooltip>
);

const renderTooltipCaseOwner = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search By Case Owner
  </Tooltip>
);
const renderTooltipCrmName = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search By Crm Name
  </Tooltip>
);
const renderTooltipsalesRep = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search By Sales Rep Name
  </Tooltip>
);

const renderTooltipSource = (props) => (
  <Tooltip id="button-tooltip" {...props}>
      Search By Source
  </Tooltip>
);


  return (
    <div className="admin-panel">
      <div id="layout-wrapper">
      <header id="page-topbar">
        <nav className="navbar navbar-expand-lg navbar-light navbar-custom">
          <div className="container-fluid">
            <a className="navbar-brand" href="#">
              <img src={ClarityLogo} alt="Bootstrap" height="45" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              {username && (
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item">
                                    <a href='#'
                                        className="nav-link"
                                        role="button"
                                    >
                                        <span
                                            className="d-xl-inline-block me-5"
                                        >
                                            Welcome {userFirstname}
                                        </span>
                                    </a>


                                </li>
                                <li className="nav-item">


                                    <a href='#'
                                        className="nav-link"
                                        role="button"
                                    >
                                        <span
                                            className="d-xl-inline-block me-5" id="headerHome"
                                        >
                                            Logout
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        )}
            </div>
          </div>
        </nav>
      </header>

      <div className="main-content home-main-content" >
        <div className="page-content">
          <div className="container-fluid home-container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="container"
                  style={{
                    maxWidth: "1440px",
                    margin: "auto",
                    marginTop: "5rem",
                  }}
                >
                  <h3 className="mb-4">New Renewal - Admin Panel</h3>
                  <div className="card mb-3">
                    <div className="card-header" id="filterHeading">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          id="filterRecords"
                          data-toggle="collapse"
                          data-target="#filterCollapse"
                          onClick={toggleCollapse} // Step 2: Attach click handler
                          aria-expanded={isOpen}
                          aria-controls="filterCollapse"
                        >
                          <FontAwesomeIcon icon={faFilter} />
                          Filters{" "}
                          <FontAwesomeIcon
                            icon={faChevronUp}
                            className={`ms-3 ${isOpen ? "rotate" : ""}`}
                          />
                        </button>
                      </h5>
                    </div>
                    {isOpen && (
                      <div
                        id="filterCollapse"
                        className="collapse show"
                        aria-labelledby="filterHeading"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-2">
                            <div className="input-group mb-3">
                            <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltip}
                                  >
                              <input
                                type="text"
                                className="form-control "
                                placeholder="Search By Client Name"
                                value={clientName}
                                onChange={handleClientNameSearch}
                                // data-toggle="tooltip"
                                // title="Enter the client's name to search."
                                // data-placement="top"
                              />
                              </OverlayTrigger>
                            </div>
                            </div>

                            

                            <div className="col-md-2">
                              <div className="input-group mb-3" >
                              <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipRenewal}
                                  >
                                <div className="dropdown bootstrap-select show-tick " style={{zIndex:999}}>
                                  {/* React Select dropdown */}
                                  <Select
                                    id="impDtFilter"
                                    className="selectpicker "
                                    options={optionsDate}
                                    isMulti
                                    placeholder="Renewal Date"
                                    value={selectedOptionsDate}
                                    onChange={handleSelectChange}
                                    isSearchable={true}
                                    classNamePrefix="react-select "
                                    aria-label="size 3 select example"

                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: '32px', // Set min height
                                        height: '32px', // Set height explicitly if necessary
                                        width: '100%', // Set width to 32px
                                        lineHeight: '1.7', // Set line height to 1.7
                                        display: 'flex',
                                        borderRadius: '2px',
                                        
                                        border: '1px solid #d2d2e4' // Ensure flex display for proper alignment
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        lineHeight: '1.7', // Set line height for value container
                                        padding: '0 4px', // Adjust padding as needed
                                        flexWrap: "nowrap", // Ensure no wrapping
                                        overflowX: "auto", // Enable horizontal scrolling
                                        textAlign: "left",
                                      }),
                                      multiValue: (provided) => ({
                                        ...provided,
                                        display: 'flex',
                                        alignItems: 'center',
                                        margin: '2px',
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: '#71748d', // Adjust this color to match your input's placeholder color
                                      }),
                                      multiValueLabel: (provided) => ({
                                        ...provided,
                                        whiteSpace: 'nowrap', // Prevent text wrapping
                                        overflow: 'hidden', // Hide overflow
                                        textOverflow: 'ellipsis', // Show ellipsis for overflow
                                      }),
                                      multiValueRemove: (provided) => ({
                                        ...provided,
                                        cursor: 'pointer',
                                      }),
                                    }}
                                    
                                  
                                  />

                                </div>
                                </OverlayTrigger>
                              </div>
                            </div>

                            <div className="col-md-2">
                            <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipCaseId}
                                  >
                              <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Search By SF Case Id"
                                value={salesforceCaseId}
                                onChange={handleSalesforceCaseIdSearch}
                              />
                              </OverlayTrigger>
                            </div>

                            {/* <SearchByProductsDropdown/>   */}

                            <div className="col-md-2">
                              <div className="input-group mb-3">
                              <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipProduct}
                                  >
                                <div className="dropdown bootstrap-select show-tick" style={{zIndex:990}}>
                                  {/* React Select dropdown */}
                                  <Select
                                    id="searchby-products"
                                    className="selectpicker"
                                    options={optionsProducts}
                                    isMulti
                                    placeholder="Search By Products"
                                    value={selectedOptionsProducts}
                                    onChange={handleSelectChangeProducts}
                                    isSearchable={true}
                                    classNamePrefix="bs-select"
                                    aria-label="size 3 select example"
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: '32px', // Set min height
                                        height: '32px', // Set height explicitly if necessary
                                        width: '100%', // Set width to 32px
                                        lineHeight: '1.7', // Set line height to 1.7
                                        display: 'flex',
                                        borderRadius: '2px',
                                        border: '1px solid #d2d2e4' // Ensure flex display for proper alignment
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        lineHeight: '1.7', // Set line height for value container
                                        padding: '0 4px', // Adjust padding as needed
                                        flexWrap: "nowrap", // Ensure no wrapping
                                        overflowX: "auto", // Enable horizontal scrolling
                                        textAlign: "left",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: '#71748d', // Adjust this color to match your input's placeholder color
                                      }),
                                    }}
                                  />
                                </div>
                                </OverlayTrigger>
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div
                                className="input-group  mb-3" >
                                  <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipCaseStatus}
                                  >
                                <div className="dropdown bootstrap-select show-tick" style={{zIndex:980}}>
                                  {/* React Select dropdown */}
                                  <Select
                                    id="caseStatusFilter"
                                    className="selectpicker "
                                    options={optionsStatus}
                                    isMulti
                                    placeholder="Case Status"
                                    value={selectedOptionsStatus}
                                    onChange={handleSelectChangeStatus}
                                    isSearchable={true}
                                    classNamePrefix="bs-select"
                                    aria-label="size 3 select example"
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: '32px', // Set min height
                                        height: '32px', // Set height explicitly if necessary
                                        width: '100%', // Set width to 32px
                                        lineHeight: '1.7', // Set line height to 1.7
                                        display: 'flex',
                                        borderRadius: '2px',
                                        border: '1px solid #d2d2e4' // Ensure flex display for proper alignment
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        lineHeight: '1.7', // Set line height for value container
                                        padding: '0 4px', // Adjust padding as needed
                                        flexWrap: "nowrap", // Ensure no wrapping
                                        overflowX: "auto", // Enable horizontal scrolling
                                        textAlign: "left",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: '#71748d', // Adjust this color to match your input's placeholder color
                                      }),
                                    }}
                                  />
                                </div>
                                </OverlayTrigger>
                              </div>
                            </div>

                           

                            <div className="col-md-2">
                              <div
                                className="input-group mb-3">
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipCaseOwner}
                                  >
                                <div className="dropdown bootstrap-select show-tick" style={{zIndex:970}}>
                                  {/* React Select dropdown */}
                                  <Select
                                    id="caseOwnerFilter"
                                    className="selectpicker"
                                    options={optionsOwner}
                                    isMulti
                                    placeholder="Case Owners"
                                    value={selectedOptionsOwner}
                                    onChange={handleSelectChangeOwner}
                                    isSearchable={true}
                                    classNamePrefix="bs-select"
                                    aria-label="size 3 select example"
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: '32px', // Set min height
                                        height: '32px', // Set height explicitly if necessary
                                        width: '100%', // Set width to 32px
                                        lineHeight: '1.7', // Set line height to 1.7
                                        display: 'flex',
                                        borderRadius: '2px',
                                        border: '1px solid #d2d2e4' // Ensure flex display for proper alignment
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        lineHeight: '1.7', // Set line height for value container
                                        padding: '0 4px', // Adjust padding as needed
                                        flexWrap: "nowrap", // Ensure no wrapping
                                        overflowX: "auto", // Enable horizontal scrolling
                                        textAlign: "left",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: '#71748d', // Adjust this color to match your input's placeholder color
                                      }),
                                    }}
                                  />
                                </div>
                                </OverlayTrigger>
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div
                                className="input-group mb-3"  >
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipCrmName}
                                  >
                                <div className="dropdown bootstrap-select show-tick" style={{zIndex:'960'}}>
                                  {/* React Select dropdown */}
                                  <Select
                                    id="crmFilter"
                                    className="selectpicker"
                                    options={optionsCrmName}
                                    isMulti
                                    placeholder="CRM Name"
                                    value={selectedOptionsCrmName}
                                    onChange={handleSelectChangeCrmName}
                                    isSearchable={true}
                                    classNamePrefix="bs-select"
                                    aria-label="size 3 select example"
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: '32px', // Set min height
                                        height: '32px', // Set height explicitly if necessary
                                        width: '100%', // Set width to 32px
                                        lineHeight: '1.7', // Set line height to 1.7
                                        display: 'flex',
                                        borderRadius: '2px',
                                        border: '1px solid #d2d2e4' // Ensure flex display for proper alignment
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        lineHeight: '1.7', // Set line height for value container
                                        padding: '0 4px', // Adjust padding as needed
                                        flexWrap: "nowrap", // Ensure no wrapping
                                        overflowX: "auto", // Enable horizontal scrolling
                                        textAlign: "left",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: '#71748d', // Adjust this color to match your input's placeholder color
                                      }),
                                    }}
                                  />
                                </div>
                                </OverlayTrigger>
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="input-group mb-3">
                                {/* React-select multi-select dropdown */}
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipsalesRep}
                                  >
                                <div className="dropdown bootstrap-select show-tick" style={{zIndex:900}}>
                                  <Select
                                    id="salesRepFilter"
                                    isMulti
                                    value={selectedSalesReps}
                                    onChange={handleSalesRepChange}
                                    options={salesRepOptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Sales Rep Name"
                                    isSearchable
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: '32px', // Set min height
                                        height: '32px', // Set height explicitly if necessary
                                        width: '100%', // Set width to 32px
                                        lineHeight: '1.7', // Set line height to 1.7
                                        display: 'flex',
                                        borderRadius: '2px',
                                        border: '1px solid #d2d2e4' // Ensure flex display for proper alignment
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        lineHeight: '1.7', // Set line height for value container
                                        padding: '0 4px', // Adjust padding as needed
                                        flexWrap: "nowrap", // Ensure no wrapping
                                        overflowX: "auto", // Enable horizontal scrolling
                                        textAlign: "left",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: '#71748d', // Adjust this color to match your input's placeholder color
                                      }),
                                    }}
                                  />
                                </div>
                                </OverlayTrigger>
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="input-group mb-3">
                                {/* React-select multi-select dropdown */}
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                   overlay={renderTooltipSource}
                                  >
                                <div className="dropdown bootstrap-select show-tick" style={{zIndex:900}}>
                                  <Select
                                    id="salesRepFilter"
                                    isMulti
                                    value={selectedSource}
                                    onChange={handleSourceChange}
                                    options={sourceOptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Source"
                                    isSearchable
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        minHeight: '32px', // Set min height
                                        height: '32px', // Set height explicitly if necessary
                                        width: '100%', // Set width to 32px
                                        lineHeight: '1.7', // Set line height to 1.7
                                        display: 'flex',
                                        borderRadius: '2px',
                                        border: '1px solid #d2d2e4' // Ensure flex display for proper alignment
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        lineHeight: '1.7', // Set line height for value container
                                        padding: '0 4px', // Adjust padding as needed
                                        flexWrap: "nowrap", // Ensure no wrapping
                                        overflowX: "auto", // Enable horizontal scrolling
                                        textAlign: "left",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        color: '#71748d', // Adjust this color to match your input's placeholder color
                                      }),
                                    }}
                                  />
                                </div>
                                </OverlayTrigger>
                              </div>
                            </div>

                            {/* <div className="col-md-2">
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    placeholder="Search By Imp Contact Email"
                                    value={impContactEmail}
                                    onChange={(e) => setImpContactEmail(e.target.value)}
                                />
                            </div> */}
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-12 text-end">
                              {/* <button
                                id="filterBtn"
                                className="btn ad-button"
                                onClick={handleFilter}
                              >
                                Search
                              </button> */}
                              <button
                                id="clearBtn"
                                className="btn clear-button"
                                onClick={handleClear}
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <AdminDataPanel
                    clientName={clientName}
                    salesforceCaseId={salesforceCaseId}
                    selectedOptionsProducts={selectedOptionsProducts}
                    selectedOptionsStatus={selectedOptionsStatus}
                    selectedOptionsCrmName={selectedOptionsCrmName}
                    selectedOptionsDate={selectedOptionsDate}
                    selectedSalesReps={selectedSalesReps}
                    selectedSource = {selectedSource}
                    selectedOptionsOwner={selectedOptionsOwner}
                    adminData={adminData}
                    filteredData={filteredData}
                    dataLoading={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    
  );
};

export default AdminPanel;
